import React from "react";
import AliianceManagerLayout from "../../../components/layouts/AliianceManagerLayout";
import AdminPageContainer from "../../../components/AdminPageContainer";
import ReferralPartnerDetails from "../../../Containers/ReferralPartnerDetails";

const ReferralPartnerDetailsPage = () => {
  return (
    <AliianceManagerLayout>
      <AdminPageContainer>
        <ReferralPartnerDetails />
      </AdminPageContainer>
    </AliianceManagerLayout>
  );
};

export default ReferralPartnerDetailsPage;
